module.exports = __webpack_public_path__ + "img/child.9e9120b0.png";